import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = ({ setSidebarOpen }) => {
  return (
    <header className="h-16 bg-white border-b border-slate-200 fixed top-0 right-0 left-0 md:left-64 z-20">
      <div className="h-full px-6 flex items-center justify-between">
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={() => setSidebarOpen(true)}
          data-testid="open-sidebar-button"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="flex-1" />
      </div>
    </header>
  );
};